import t from"@emotion/styled";import{setFontSize as a,setColor as e,setRadius as p}from"../../utils/generateStyles.js";var c=Object.defineProperty,g=Object.defineProperties,b=Object.getOwnPropertyDescriptors,d=Object.getOwnPropertySymbols,u=Object.prototype.hasOwnProperty,y=Object.prototype.propertyIsEnumerable,s=(r,o,l)=>o in r?c(r,o,{enumerable:!0,configurable:!0,writable:!0,value:l}):r[o]=l,n=(r,o)=>{for(var l in o||(o={}))u.call(o,l)&&s(r,l,o[l]);if(d)for(var l of d(o))y.call(o,l)&&s(r,l,o[l]);return r},i=(r,o)=>g(r,b(o));const x=r=>r==="xl"?i(n({},a("sm")),{lineHeight:"22px",padding:"13px 8px",height:"48px"}):r==="lg"?i(n({},a("sm")),{lineHeight:"22px",padding:"9px 8px",height:"40px"}):i(n({},a("xs")),{padding:"7px",height:"32px"}),f=t.div`
  label: input-root;
  display: flex;
  flex-direction: column;
  width: 100%;
`,h=t.label`
  label: input-label;
  display: flex;
  margin-bottom: 2px;
  padding-right: 8px;
  font-weight: 400;
  ${()=>a("xs")}
  ${()=>e("gray-140","color")}
  ${r=>(r.disabled||r.isLoading)&&e("gray-60","color")}
`,$=t.div`
  label: input-container;
  display: flex;
  position: relative;
  width: 100%;
  overflow: hidden;
  border: 1px solid;
  ${()=>e("gray-90","borderColor")}
  ${r=>r.readOnly&&e("gray-60","backgroundColor")};
  ${r=>r.disabled&&n(n({backgroundColor:"transparent"},e("gray-60","borderColor")),e("gray-60","color"))}
  &:hover {
    ${()=>e("gray-100","borderColor")}
    ${r=>r.readOnly&&e("gray-90","borderColor")};
    ${r=>r.disabled&&e("gray-60","borderColor")};
    ${r=>r.error&&e("error-DEFAULT","borderColor")};
    ${r=>r.success&&e("success-DEFAULT","borderColor")};
  }
  &:focus-within {
    ${()=>e("gray-100","borderColor")}
    ${r=>r.readOnly&&e("gray-90","borderColor")};
    ${r=>r.error&&e("error-DEFAULT","borderColor")};
    ${r=>r.success&&e("success-DEFAULT","borderColor")};
  }
  ${r=>p(r.isCornerMax?"full":"md")}
  ${r=>r.error&&i(n({},e("error-DEFAULT","borderColor")),{["&::placeholder"]:e("error-DEFAULT","borderColor"),["&:focus"]:e("error-DEFAULT","borderColor")})};
  ${r=>r.success&&i(n({},e("success-DEFAULT","borderColor")),{["&::placeholder"]:e("success-DEFAULT","borderColor"),["&:focus"]:e("success-DEFAULT","borderColor")})}
`,m=t.div`
  label: input-start-adornment;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding-right: 8px;
`,C=t.input`
  label: input;
  display: flex;
  flex: 1 1 0%;
  width: 100%;
  height: 100%;
  padding: 0 8px;
  font-weight: 500;
  text-align: center;
  border: none;
  outline: none;
  background-color: transparent;
  ${()=>e("gray-100","color")}
  ${r=>r.isLoading&&{pointerEvents:"none",["&::placeholder"]:e("gray-60","color")}};
  &:disabled {
    &::placeholder {
      ${()=>e("gray-60","color")}
    }
  }
  &::placeholder {
    text-align: right;
    font-weight: 400;
    ${()=>e("gray-100","color")}
    ${()=>a("xs")}
    padding: 0 8px;
  }
  ${r=>x(r.size)}
`,v=t.div`
  label: input-loader;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding-left: 8px;
`,L=t.div`
  label: input-end-adornment;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding-left: 8px;
`,E=t.div`
  label: input-footer;
  display: flex;
  flex: 1 1 0%;
  margin-top: 2px;
  ${r=>a(r.size==="md"?"xxs":"xs")}
`,S=t.p`
  label: input-helper-text;
  display: flex;
  flex: 1 1 0%;
  padding-right: 8px;
  align-items: center;
  margin: 0;
  ${r=>e(r.disabled||r.isLoading?"gray-60":r.error?"error-DEFAULT":r.success?"success-DEFAULT":"gray-140","color")}
`,A=t.span`
  label: input-status-icon;
  display: inline-flex;
  margin-left: 2px;
`;export{$ as InputContainerStyled,L as InputEndAdornmentStyled,E as InputFooterStyled,S as InputHelperTextStyled,h as InputLabelStyled,v as InputLoaderStyled,f as InputRootStyled,m as InputStartAdornmentStyled,A as InputStatusIconStyled,C as InputStyled};
